import { StudioVisualizationConfig, StudioVisualizationType } from '@blockworks/platform/api/research/studio';

const getTableVisualizationPageSize = (passedConfig?: StudioVisualizationConfig<any>) => {
    const config = passedConfig as StudioVisualizationConfig<StudioVisualizationType.Table>;
    if (!config) return undefined;

    const tablePageSize = config.options?.pageSize;
    if (tablePageSize) {
        return tablePageSize;
    }

    return undefined;
};

export { getTableVisualizationPageSize };
